module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_NL-88ab0e9decfc7dbbbed0b0529801d88f.svg";